export enum CalendarLoadModeEnum {
    ByCurrentUser = 'by-current-user',
    ByMember = 'by-member',
    ByProviders = 'by-providers',
    ByAllProviders = 'by-all-providers',
    ByExternalProvider = 'by-external-provider',
    ByMemberAndProviders = 'by-member-and-providers',
}
